import axios from 'axios';

export default function setAuthorizationToken(token) {
  if (token) {
    axios.defaults.headers.common['authorization'] = `${token}`;
  } else {
    delete axios.defaults.headers.common['authorization'];
  }
}



// WEBPACK FOOTER //
// ./src/utils/setAuthorizationToken.js